/**
 * @file Defines the {@link Action} classs
 * @author Joe Thompson <joe.thompson@1x2gaming.com>
 */

 /** Class for handling custom events */
 export class Action {

    /**
     * Map of callbacks to execute when dispatched
     * @memberof Action
     * @protected
     * @instance
     * @type {Map<function, function>}
     */
    _listeners

    /**
     * Map of callbacks to execute on the next dispatch
     * @memberof Action
     * @protected
     * @instance
     * @type {Map<function, function>}
     */
    _once

    /** Initialize Maps for callbacks */
    constructor() {

        this._listeners = new Map()
        this._once      = new Map()

    }

    /**
     * Adds a listener to map of callbacks
     * @param {function} f_ - Function to be added as a listener
     * @return {boolean} Whether input added or not
     */
    add(f_) {

        let v = false //Value to return

        //If input is function
        if (typeof f_ === 'function') {

            this._listeners.set(f_, f_) //Set listener
            v = true                    //Return added

        }

        return v //Return whether input added

    }

    /**
     * Adds a listener to be executed only on the next dispatch
     * @param {function} f_ - Function to be added as a listener
     * @return {boolean} Whether input added or not
     */
    once(f_) {

        let v = false //Value to return

        //If input is function
        if (typeof f_ === 'function') {

            this._once.set(f_, f_) //Set listener
            v = true               //Return added

        }

        return v //Return whether input added
        
    }

    /**
     * Removes a listener
     * @param {function} f_ - Listener to be removed
     * @return {boolean} Whether listener was removed successfully or not
     */
    remove(f_) {
        return this._listeners.delete(f_) //Attempt to remove and return fail/success
    }

    /**
     * Dispatch an event and fire listener callbacks
     * @param  {...*} args_ - Rest parameter containing arguments for listeners
     */
    dispatch(...args_) {

        this._listeners.forEach(f_ => f_.apply(f_, args_)) //Fire listeners
        this._once.forEach(f_ => f_.apply(f_, args_))      //Fire listeners for this dispatch

        delete this._once      //Delete listeners for this dispatch
        this._once = new Map() //Initialise listeners for next dispatch

    }

 }